module.exports = __webpack_public_path__ + "static/img/230825_BB_TripleBerry_Smiley_Anim01_1.59d4292.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mixology/smiles/230825_BB_TripleBerry_Smiley_Anim01_1.gif
// module id = Zo+G
// module chunks = 0